import { SelectProps } from "@cofano/cck/Select/Select";
import { DemurrageCountingType } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const DemurrageCountingTypeSelect = ({ value, onChange }: Omit<SelectProps<DemurrageCountingType, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(DemurrageCountingType)}
			getOptionLabel={(option) => intl.formatMessage({ id: `DEMURRAGE_COUNTING_TYPE_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default DemurrageCountingTypeSelect;
